import { Anchor, Group } from "@mantine/core";
import { Link, useMatches } from "react-router-dom";
import classes from "./NavbarLinksGroup/NavbarLinksGroup.module.css";
import { useUIStore } from "../../stores/UIStore";

const NavItemMenu = ({ item }) => {
  const matches = useMatches();

  return (
    <Anchor
      className={`${classes.link} nav-link`}
      component={Link}
      to={item?.path || undefined}
      style={{
        color: matches.find((x) => x.pathname.includes(item.path))
          ? "var(--mantine-primary-color-filled)"
          : "var(--mantine-color-dark-3)",
        // borderLeft: matches.find((x) => x.pathname.includes(item.path))
        //   ? "6px solid var(--mantine-primary-color-filled)"
        //   : undefined,
        background: matches.find((x) => x.pathname.includes(item.path))
          ? "var(--mantine-color-primary-0)"
          : undefined,
      }}
      underline="never"
      fw={matches.find((x) => x.pathname.includes(item.path)) ? 650 : 550}
      display={"flex"}
      id={item?.id}
      fz={13}
      onClick={() => {
        let locked = useUIStore.getState().pinnedNavbar;
        if (!locked) {
          useUIStore.getState().setNavbarClosed(true);
          useUIStore.getState().setCampaignOpened(false);
        }
      }}
    >
      <Group pl={64} id={item.id} w={"100%"} pr={"sm"} py={"xs"}>
        {item.name}
      </Group>
    </Anchor>
  );
};

export default NavItemMenu;
